module.exports = __webpack_public_path__ + "static/Holiday_Build_My_Book-b887b283b45509f563075a24021aa6f2.jpg";